import { render, staticRenderFns } from "./SharedLinkAccessDeniedPage.vue?vue&type=template&id=4f2aafa5&scoped=true"
import script from "./SharedLinkAccessDeniedPage.vue?vue&type=script&lang=ts"
export * from "./SharedLinkAccessDeniedPage.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkAccessDeniedPage.vue?vue&type=style&index=0&id=4f2aafa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2aafa5",
  null
  
)

export default component.exports